import { useTranslation } from 'next-i18next';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

import { useCreatePeriodicOperationUtils } from '@/modules/periodicTasks/components/Create/logic';
import { IPeriodicTasks } from '@/modules/periodicTasks/types';
import { useGetPropertyConfigurations } from '@/modules/settings/property/apiHooks';
import LinkedInputs from '@/shared/components/molecules/LinkedInputs';
import { useStore } from '@/shared/hooks/context/createGenericContext';

const WaterAmount = () => {
  const { t } = useTranslation();

  const [selectedAsset] = useStore((store) => store?.asset);

  const { getPlotsTotalWorkingArea } = useCreatePeriodicOperationUtils();

  const { data: configurations } = useGetPropertyConfigurations(
    selectedAsset?.id
  );

  const {
    watch,
    setValue,
    getValues,
    formState: { errors },
  } = useFormContext<IPeriodicTasks.IOperationFormSchema>();
  const plots = watch('plots');

  const plotsTotalWorkingArea = getPlotsTotalWorkingArea(plots);

  const handleRateChange = (value: string) => {
    const rate = Number(value);
    const amountVal = value ? plotsTotalWorkingArea * rate : null;
    setValue('products.0.amount', amountVal, { shouldValidate: true });
  };

  const handleAmountChange = (value: string) => {
    const amountValue = Number(value);
    const rateVal = value ? amountValue / plotsTotalWorkingArea : null;
    setValue('products.0.rate', rateVal, { shouldValidate: true });
  };

  useEffect(() => {
    const rateValue = getValues('products.0.rate');
    if (rateValue)
      setValue('products.0.amount', (plotsTotalWorkingArea ?? 1) * rateValue);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [plotsTotalWorkingArea]);

  useEffect(() => {
    setValue('products.0.unit', 'm3');
    setValue('products.0.product.product_id', 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <LinkedInputs
      inputProps={[
        {
          id: 'products.0.rate',
          error: !!errors?.products?.[0]?.rate,
          errorMessage: errors?.products?.[0]?.rate?.message,
          label: t('rate-rate'),
          placeholder: t('rate-rate'),
          disabled: plots.length < 1,
          onChange: (event) => handleRateChange(event.target.value),
          suffix: (
            <>
              {`${t('m3')}${
                configurations?.areaUnit ? `/${t(configurations.areaUnit)}` : ''
              }`}
            </>
          ),
        },
        {
          id: 'products.0.amount',
          error: !!errors?.products?.[0]?.amount,
          errorMessage: errors?.products?.[0]?.amount?.message,
          label: t('total-quantity'),
          placeholder: t('total-quantity'),
          disabled: plots.length < 1,
          onChange: (event) => handleAmountChange(event.target.value),
          suffix: <>{t('m3')}</>,
        },
      ]}
    />
  );
};

export default WaterAmount;
